import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fb } from '../utils/fb';
import { api } from '../utils/api';
import './Header.css';

function SlidNav({ openSlideNav, setOpenSlidNav, setSlidBarPOsition, profileActive, setProfileActive }) {
    const [isLogin, setIsLogin] = useState(false);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("user_profile")) );
    useEffect(() => {
        fb.loadScript().then(() => fb.init());

        if (!localStorage.getItem('aws_JWT')) {
            setIsLogin(false);
        } else {
            setIsLogin(true);
        }
    }, []);

    const logOut = () => {
        fb.logout();
        localStorage.removeItem('user_profile');
        localStorage.removeItem('aws_JWT');
        setIsLogin(false);

        setTimeout(() => {
            window.location.pathname = "/"
        })
    };

    const loginFB = () => {
        fb.login()
            .then((response) => {
                if (response.status === 'connected') {
                    return Promise.resolve(response.authResponse.accessToken);
                }
                return Promise.reject('登入失敗');
            })
            .then((accessToken) => {
                return api.signin({
                    provider: 'facebook',
                    access_token: accessToken,
                });
            })
            .then((json) => {
                window.localStorage.setItem('aws_JWT', json.data.access_token);
                return api.getProfile(json.data.access_token);
            })
            .then((json) => {
                localStorage.setItem('user_profile', JSON.stringify(json.data));
                setProfile(json.data);
                setIsLogin(true);
            })
            .catch((error) => window.alert(error));
    };
    const handleCloseNavBtn = () => {
        let pathName = window.location.pathname.split("/")
        if(pathName[1] !== 'profile') {
            setOpenSlidNav(false)
            setProfileActive(null)
        }else {
            setOpenSlidNav(false)
        }
    }
    const handleActive = (position, activeBtn) =>{
        setSlidBarPOsition(position)
        setProfileActive(activeBtn)
    }
    return (
        <>
            {isLogin ? (
                <nav className="profile__nav" style={{ right: !openSlideNav ? '-300px' : '0' }}>
                    <span className="close__btn" onClick={handleCloseNavBtn}></span>
                    <div className="profile__nav__info">
                        <h5>Hello {profile.name}</h5>
                        <h6>{profile.email}</h6>
                    </div>
                    <Link className={`profile__nav__link ${profileActive === "profileInfo" ? "active_text" : ""}`} to="/profile" onClick={() =>handleActive(0, "profileInfo")}>
                        <div className="profile__link-icon-profile profile__link-icon" />
                        <div className="profile__link-text">我的檔案</div>
                    </Link>
                    <Link className={`profile__nav__link ${profileActive === "orderhistory" ? "active_text" : ""}`} to="/profile/orderhistory" onClick={() =>handleActive("calc(100% / 3 *1)", "orderhistory")}>
                        <div className="profile__link-icon-orderhistory profile__link-icon" />
                        <div className="profile__link-text">已完成訂單</div>
                    </Link>
                    <Link className={`profile__nav__link ${profileActive === "favoritelist" ? "active_text" : ""}`} to="/profile/favoritelist" onClick={() =>handleActive("calc(100% / 3 *2)", "favoritelist")}>
                        <div className="profile__link-icon-favorite profile__link-icon" />
                        <div className="profile__link-text">按讚好物</div>
                    </Link>
                    <button className="logout__btn" type="button" onClick={() => logOut()}>
                        LOG OUT
                    </button>
                </nav>
            ) : (
                <nav className="profile__nav" style={{ right: !openSlideNav ? '-300px' : '0' }}>
                    <span className="close__btn" onClick={() => setOpenSlidNav(false)}></span>
                    <button type="button" className="fbLogin_btn" onClick={() => loginFB()}>
                        use Facebook Login
                    </button>
                </nav>
            )}
        </>
    );
}

export default function Header(props) {
    const [inputValue, setInputValue] = useState(''); // inputValue: string
    const [openSlideNav, setOpenSlidNav] = useState(false);
    const category = new URLSearchParams(window.location.search).get('category');

    return (
        <div className="header">
            <Link className="header__logo" to="./" />
            <div className="header__categories">
                <Link className={`header__category${category === 'women' ? ' header__category--active' : ''}`} to="./?category=women">
                    女裝
                </Link>
                <Link className={`header__category${category === 'men' ? ' header__category--active' : ''}`} to="./?category=men">
                    男裝
                </Link>
                <Link className={`header__category${category === 'accessories' ? ' header__category--active' : ''}`} to="./?category=accessories">
                    配件
                </Link>
                <Link className={`header__category_sale header__category${category === 'sale' ? ' header__category--active' : ''}`} to="./sale">
                    SALE
                </Link>
            </div>
            <input
                className="header__search-input"
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        window.location.href = `./?q=${inputValue}`;
                    }
                }}
                onChange={(e) => setInputValue(e.target.value)}
                value={inputValue}
            />
            <div className="header__links">
                <Link className="header__link" to="./cart">
                    <div className="header__link-icon-cart">
                        <div className="header__link-icon-cart-number">{props.cartItems.reduce((prev, item) => prev + item.qty, 0)}</div>
                    </div>
                    <div className="header__link-text">購物車</div>
                </Link>
                <div>
                    <button className="header__link" onClick={() => (openSlideNav ? setOpenSlidNav(false) : setOpenSlidNav(true))}>
                        <div className="header__link-icon-profile" />
                        <div className="header__link-text">會員</div>
                    </button>
                    <SlidNav openSlideNav={openSlideNav} setOpenSlidNav={setOpenSlidNav} setSlidBarPOsition={props.setSlidBarPOsition} setProfileActive={props.setProfileActive} 
                    profileActive={props.profileActive}/>
                </div>
            </div>
        </div>
    );
}
